import LetterPostboxesTable from './letterPostboxesTable';

export default LetterPostboxesTable;
